import { render, staticRenderFns } from "./ProcessAtributeMain.vue?vue&type=template&id=58551202"
import script from "./ProcessAtributeMain.vue?vue&type=script&lang=js"
export * from "./ProcessAtributeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports